module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "page-header"
  }, [_vm._v("Support")]), _vm._v(" "), _c('div', {
    staticClass: "dsp-wrapper"
  }, [_c('h3', [_vm._v("Select a local provider for contact information.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getDSPInfo()
      }]
    }
  }, _vm._l((_vm.DSPs), function(dsp) {
    return _c('option', {
      domProps: {
        "value": dsp.UNIX_USER
      }
    }, [_vm._v("\n              " + _vm._s(dsp.BUS_CITY + ' - ' + dsp.BUS_NAME) + "\n            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "dsp_info"
  }, [(_vm.dspInfo.BUS_NAME) ? _c('h4', [_vm._v(_vm._s(_vm.dspInfo.BUS_NAME))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.SITE_URL) ? _c('p', [_vm._v("Website: " + _vm._s(_vm.dspInfo.SITE_URL))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.BUS_PHONE) ? _c('p', [_vm._v("Phone: " + _vm._s(_vm.dspInfo.BUS_PHONE))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.SITE_NOTIFY_COMMENTS) ? _c('p', [_vm._v("Email: " + _vm._s(_vm.dspInfo.SITE_NOTIFY_COMMENTS))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.BUS_ADDRESS1) ? _c('p', [_vm._v("Address: " + _vm._s(_vm.dspInfo.BUS_ADDRESS1))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.BUS_CITY) ? _c('p', [_vm._v("City: " + _vm._s(_vm.dspInfo.BUS_CITY))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.BUS_STATE) ? _c('p', [_vm._v("State: " + _vm._s(_vm.dspInfo.BUS_STATE))]) : _vm._e(), _vm._v(" "), (_vm.dspInfo.BUS_ZIP) ? _c('p', [_vm._v("Zip: " + _vm._s(_vm.dspInfo.BUS_ZIP))]) : _vm._e()])])])]), _vm._v(" "), (_vm.selected != 'null') ? _c('div', {
    ref: "national_support",
    staticClass: "support_info"
  }, [_c('h3', {
    staticClass: "national_support"
  }, [_vm._v("National Support")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "35px"
    }
  }, [_vm._v("If your issue was not resolved contacting your local provider, please reach out to our national support hotline.")]), _vm._v(" "), _vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "support-card"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/support_feedback.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('h3', [_vm._v("We want your feedback! Email us anytime "), _c('a', {
    attrs: {
      "href": "mailto:wecare@deliverlogic.com"
    }
  }, [_vm._v("wecare@deliverlogic.com")])]), _vm._v(" "), _c('p', [_vm._v("Please include following information in your email (if applicable)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Date and time of interaction")]), _vm._v(" "), _c('li', [_vm._v("Customer name")]), _vm._v(" "), _c('li', [_vm._v("Order number")]), _vm._v(" "), _c('li', [_vm._v("Driver name (if applicable)")]), _vm._v(" "), _c('li', [_vm._v("Deliver service (if applicable)")]), _vm._v(" "), _c('li', [_vm._v("Detailed comments")])]), _vm._v(" "), _c('p', [_vm._v("Feedback can include any of the following")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Customer feedback")]), _vm._v(" "), _c('li', [_vm._v("Wait times")]), _vm._v(" "), _c('li', [_vm._v("Driver interaction (positive or negative)")]), _vm._v(" "), _c('li', [_vm._v("Process improvements")]), _vm._v(" "), _c('li', [_vm._v("Anything else you would like to communicate to us!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "support-card orange_sep"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/support_driver.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('h3', [_vm._v("If the delivery service is going to be delayed for "), _c('strong', [_vm._v("ANY")]), _vm._v(" reason (i.e. traffic, weather), "), _c('br'), _vm._v("DeliverLogic will...")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Contact your "), _c('strong', [_vm._v("store")]), _vm._v(" to advise of the new arrival time")]), _vm._v(" "), _c('li', [_vm._v("Contact your "), _c('strong', [_vm._v("customer")]), _vm._v(" to provide them with a new update")]), _vm._v(" "), _c('li', [_vm._v("Provide the "), _c('strong', [_vm._v("customer compensation")]), _vm._v(" for any of the following issues:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Excessive delivery times")]), _vm._v(" "), _c('li', [_vm._v("Poor food quality as a result of lengthy delivery times")]), _vm._v(" "), _c('li', [_vm._v("Food never arriving")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row orange_sep"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("If you are experiencing an emergency service issue "), _c('br'), _vm._v("please call our "), _c('strong', [_vm._v("Emergency Support Number")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/support_contact.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("(833) 435 - 6442")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b883cf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Support.vue
// module id = 361
// module chunks = 1